// export const getProducts = (store) => store.data.products;
export const getFacilities = (store) => store.app.facilities;
